import { CommunicationAttachment } from './communication-upload.models';
export enum CommunicationLevel {
  Information = 0,
  ModerateAlert = 1,
  StrongAlert = 2,
}

export enum InfoAudienceTargetType {
  National = 0,
  Region = 1,
  Store = 2,
  Sector = 3,
}

export interface InfoAudienceTarget {
  type: InfoAudienceTargetType;
  regionId?: string;
  storeId?: string;
  sector?: string;
  label?: string;
}

export function areSameInfoAudienceTarget(first: InfoAudienceTarget, second: InfoAudienceTarget): boolean {
  if (first.type !== second.type) return false;

  switch (first.type) {
    case InfoAudienceTargetType.National:
      return true;
    case InfoAudienceTargetType.Region:
      return first.regionId === second.regionId;
    case InfoAudienceTargetType.Store:
      return first.storeId === second.storeId;
    case InfoAudienceTargetType.Sector:
      return first.sector === second.sector;
    default:
      return false;
  }
}

export interface HeadOfficeInfo {
  id: string;
  level: CommunicationLevel;
  title: string;
  theme: string;
  content: string;
  publishingTeam: string;
  publicationUtc: string;
  createdUtc: string;
  updatedUtc: string;
  isActive: boolean;
  deactivatedUtc?: string;
  status: 'inactive' | 'scheduled' | 'published';
  author: string;
  isRead: boolean;
  targets: InfoAudienceTarget[];
  attachments: CommunicationAttachment[];
}

export interface HeadOfficeInfoInput {
  title: string;
  level: CommunicationLevel;
  theme: string;
  content: string;
  publishingTeam: string;
  publicationUtc: string;
  resetReadStates: boolean;
  targets: InfoAudienceTarget[];
  uploadIds: string[];
  existingAttachmentIds: string[];
}

export interface ReferentialItem {
  id: string;
  label: string;
}

export interface CommunicationReferential {
  regions: ReferentialItem[];
  stores: ReferentialItem[];
  sectors: string[];
}
